import { Icon as BlueIcon, IconName } from '@blueprintjs/core';
import { getUpdateFlagColor } from '@utils';
import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { format } from 'date-fns';
import AddUserIcon from '@assets/svg/add-user.svg';
import ReactTooltip from 'react-tooltip';
import { IUpdateRawQueryList } from '@models/Update.model';
import { Label } from '@pages/Products/components/ListProducts/ListProducts.styles';
import {
  // TableBody,
  // WrapperRow,
  Text,
  // Divider,
  // RowPrioritized,
  Assignee,
  // TablePrioritizedHeader,
  // RowInnerPrioritized,
  Empty,
} from '../../Updates.styles';
import { ColumnNames } from './NewTable';

export function getUpdateCell(
  cell: ColumnNames,
  updateStatus: IUpdateRawQueryList,
): React.ReactNode {
  let renderCell: React.ReactNode = <></>;
  switch (cell) {
    case 'Status':
      renderCell = (
        <>
          <BlueIcon
            icon={getIcon(updateStatus)}
            color={getIconColor(updateStatus)}
            data-tip
            data-for={`helpTooltip ${updateStatus.id}`}
          />
          <ReactTooltip
            className="tooltip"
            id={`helpTooltip ${updateStatus.id}`}
            effect="solid"
            place="bottom"
            multiline
            backgroundColor="#161A30"
          >
            {ToolTipsText(updateStatus)}
          </ReactTooltip>
        </>
      );
      break;
    case 'Subject':
      renderCell = <Text className="rowText">{updateStatus.subject}</Text>;
      break;
    case 'Assignee':
      renderCell = [UpdateStatusType.NEW, UpdateStatusType.DISMISSED].includes(
        updateStatus.usType,
      ) ? (
        <Empty>N/A</Empty>
      ) : (
        <>
          {updateStatus.aAvatar ? (
            <Assignee src={updateStatus.aAvatar} />
          ) : (
            <img src={AddUserIcon} alt="add assignee" />
          )}
        </>
      );
      break;
    case 'Date':
      renderCell = (
        <Text className="rowText">
          {updateStatus.date && format(updateStatus.date, 'MM/dd/yyyy')}
        </Text>
      );
      break;
    default:
      break;
  }
  return <Label>{renderCell}</Label>;
}
function ToolTipsText({ usType, priority }: IUpdateRawQueryList) {
  if (usType === UpdateStatusType.NEW) return 'New';
  if (usType === UpdateStatusType.COMPLETED) return 'Completed';
  if (usType === UpdateStatusType.PRIORITIZED) {
    if (priority === UpdateStatusPriority.URGENT) return 'Urgent';
    if (priority === UpdateStatusPriority.IMPORTANT) return 'Important';
    if (priority === UpdateStatusPriority.NONCRITICAL) return 'Non-critical';
    return 'Uncertain';
  }

  return 'Dismissed';
}
function getIcon({ usType }: IUpdateRawQueryList): IconName {
  if (usType === UpdateStatusType.NEW) return 'record';
  if (usType === UpdateStatusType.PRIORITIZED) return 'flag';
  if (usType === UpdateStatusType.COMPLETED) return 'tick-circle';

  return 'disable';
}
function getIconColor({ usType, priority }: IUpdateRawQueryList) {
  if (usType === UpdateStatusType.NEW) return '#C1C4D6';
  if (usType === UpdateStatusType.PRIORITIZED) {
    return getUpdateFlagColor(priority);
  }

  return '#8F95B2';
}
